import React from "react";
import {
  Container,
  Box,
  ButtonGroup,
  styled,
  FormControl,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { CustomIconButton } from "../Buttons/IconButton";
import { useState, useEffect } from "react";
// import {
//   KeyboardArrowLeft,
//   KeyboardArrowRight,
//   KeyboardDoubleArrowRight,
//   KeyboardDoubleArrowLeft,
//   NoDrinksOutlined,
//   ArrowBackIcon,
//   ArrowForwardIcon
// } from "@mui/icons-material";
import { Pagination, PaginationItem } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { BorderBottom } from "@mui/icons-material";

export const StyledContainer = styled(Container)({
  marginTop: 10,
  display: "flex",
  justifyContent: "space-between",
  flexWrap: "wrap",
});
export const StyledButtonGroup = styled(ButtonGroup)({
  width: "33%",
  display: "flex",
  justifyContent: "space-between",
});
export const StyledBox = styled(Box)({
  display: "flex",
  justifyContent: "flex-end",
  width: "33%",
});

export const StyledFormControl = styled(FormControl)({
  width: 70,
  height: 30,
  marginRight: "20px",
});
const StyledTypography = styled(Typography)({
  fontSize: "13px",
  color: "#000",
  fontFamily: "Calibri",
  fontWeight: "300px",
  lineHeight: "21px",
});
const style = {
  icon: {
    width: 10,
    height: 10,
  },
  button: {
    color: "#F2EFEB",
  },
};

export const PageButton = ({
  pageNo,
  setPageNo,
  limit,
  setLimit,
  totalCount,
  noOfPages,
  startAt,
  endAt,
}) => {
  const [leftDoubleArrowColor, setLeftDoubleArrowColor] = useState("#D1D1D4");
  const [leftSingleArrowColor, setLeftSingleArrowColor] = useState("#D1D1D4");
  const [rightSingleArrowColor, setRightSingleArrowColor] = useState("#333230");
  const [rightDoubleArrowColor, setRightDoubleArrowColor] = useState("#333230");
  useEffect(() => {
    setLeftDoubleArrowColor(pageNo > 1 ? "#333230" : "#D1D1D4");
    setLeftSingleArrowColor(pageNo > 1 ? "#333230" : "#D1D1D4");
    setRightSingleArrowColor(endAt < totalCount ? "#333230" : "#D1D1D4");
    setRightDoubleArrowColor(endAt < totalCount ? "#333230" : "#D1D1D4");
  }, [pageNo, endAt, totalCount]);

  const handlePageChange = (event, value) => {
    setPageNo(value);
  };
  const handleNumberInputChange = (event) => {
    const currentNoOfPages = Math.ceil(totalCount / event.target.value);

    if (pageNo >= currentNoOfPages) {
      setPageNo(currentNoOfPages);
    }
    setLimit(event.target.value);
  };
  // const advancePageNo = () => {
  //   if (endAt < totalCount) {
  //     setPageNo((prevpageNo) => prevpageNo + 1);
  //     setLeftDoubleArrowColor("#333230"); //enabled
  //     setLeftSingleArrowColor("#333230"); //enabled
  //   }
  //   if (endAt == totalCount - (totalCount % limit)) {
  //     setRightDoubleArrowColor("#D1D1D4"); //disabled;
  //     setRightSingleArrowColor("#D1D1D4"); //disabled;
  //     setLeftDoubleArrowColor("#333230");
  //     setLeftSingleArrowColor("#333230");
  //   }
  // };
  // const backwardPageNo = () => {
  //   if (pageNo > 1) {
  //     setPageNo((prevpageNo) => prevpageNo - 1);
  //     setRightDoubleArrowColor("#333230"); //enabled
  //     setRightSingleArrowColor("#333230"); //enabled
  //   }
  //   if (pageNo - 1 == 1) {
  //     setRightDoubleArrowColor("#333230"); //enabled
  //     setRightSingleArrowColor("#333230"); //enabled
  //     setLeftDoubleArrowColor("#D1D1D4"); //diabled
  //     setLeftSingleArrowColor("#D1D1D4"); //disabled
  //   }
  // };

  // const handleleftDoubleArrowClick = () => {
  //   setPageNo(1);
  //   setRightDoubleArrowColor("#333230");
  //   setRightSingleArrowColor("#333230");
  //   setLeftDoubleArrowColor("#D1D1D4");
  //   setLeftSingleArrowColor("#D1D1D4");
  // };

  // const handleRightDoubleArrowClick = () => {
  //   setPageNo(noOfPages);
  //   setRightDoubleArrowColor("#D1D1D4");
  //   setRightSingleArrowColor("#D1D1D4");
  //   setLeftDoubleArrowColor("#333230");
  //   setLeftSingleArrowColor("#333230");
  // };

  return (
    <StyledContainer>
      <StyledBox></StyledBox>
      <Box>
        {/* <StyledButtonGroup>
          <CustomIconButton
            color={style.button.color}
            fontColor={leftDoubleArrowColor}
            onClick={() => handleleftDoubleArrowClick()}
          >
            <KeyboardDoubleArrowLeft sx={style.icon} />
          </CustomIconButton>
          <CustomIconButton
            color={style.button.color}
            fontColor={leftSingleArrowColor}
            onClick={() => backwardPageNo()}
          >
            <KeyboardArrowLeft sx={style.icon} />
          </CustomIconButton>
          <CustomIconButton color="#7CBA25" fontColor="#fffffF">
            {pageNo}
          </CustomIconButton>
          <CustomIconButton
            color={style.button.color}
            fontColor={rightSingleArrowColor}
            onClick={() => advancePageNo()}
          >
            <KeyboardArrowRight sx={style.icon} />
          </CustomIconButton>
          <CustomIconButton
            color={style.button.color}
            fontColor={rightDoubleArrowColor}
            onClick={() => handleRightDoubleArrowClick()}
          >
            <KeyboardDoubleArrowRight sx={style.icon} />
          </CustomIconButton>
        </StyledButtonGroup> */}
        <Pagination
          count={noOfPages}
          page={pageNo}
          onChange={handlePageChange}
          size="small"
          renderItem={(item) => (
            <PaginationItem
              sx={{
                "&.Mui-selected": {
                  backgroundColor: "transparent",
                  textDecoration: "underline",
                },
                "&.Mui-selected:hover": {
                  backgroundColor: "transparent",
                  textDecoration: "underline",
                },

                "&:hover": {
                  textDecoration: "underline", // make the background square
                   // change background color on hover
                   backgroundColor:"transparent"
                },
              }}
              slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
              {...item}
            />
          )}
        ></Pagination>
      </Box>

      <StyledBox>
        <StyledFormControl>
          <Select
            sx={{ height: 22, width: 80 }}
            onChange={handleNumberInputChange}
            value={limit}
          >
            <MenuItem value={5}>5</MenuItem>
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={15}>15</MenuItem>
          </Select>
        </StyledFormControl>
        <StyledTypography>
          Showing {startAt}-{endAt} of{" "}
          {totalCount <= 100 ? totalCount : totalCount + "+"}
        </StyledTypography>
      </StyledBox>
    </StyledContainer>
  );
};
